
  import {Component, Vue} from 'vue-property-decorator';

  import Attachments from "@/components/Attachments.vue";

  // import FileUpload from "primevue/fileupload";
  // import DataTable from "primevue/datatable";
  // import Column from "primevue/column";
  // import ProgressBar from "primevue/progressbar";
  // import Dropdown from "primevue/dropdown";
  //
  // Vue.component("FileUpload", FileUpload);
  // Vue.component("DataTable", DataTable);
  // Vue.component("Column", Column);
  // Vue.component("ProgressBar", ProgressBar);
  // Vue.component("Dropdown", Dropdown);

  @Component({
    components: {
      Attachments,
    },
  })
  export default class Home extends Vue {

  }
